import bigCursorIcon from "../icons/bigCursorIcon.svg"
import readingGuideIcon from "../icons/readingGuideIcon.svg"
import screenReaderIcon from "../icons/screenReaderIcon.svg"
import pageStructureIcon from "../icons/pageStructureIcon.svg"
import superFocusIcon from "../icons/superFocusIcon.svg"

export default [
    {
        label: 'Super Focus',
        key: 'super-focus',
        icon: superFocusIcon,
    },
    {
        label: 'Screen Reader',
        key: 'screen-reader',
        icon: screenReaderIcon,
    },
    {
        label: 'Reading Guide',
        key: 'readable-guide',
        icon: readingGuideIcon,
    },
    {
        label: 'Big Cursor',
        key: 'big-cursor',
        icon: bigCursorIcon,
    },
    {
        label: 'Page Structure',
        key: 'page-structure',
        icon: pageStructureIcon,
    },
]
